/* Also: phone lightbox swipe counter and open-on-clicked-photo. */
/* Columns gallery: photo 1 full width, photos 2-5 medium, photo 6+ in a carousel underneath. Desktop/tablet only. */
(function () {
  var KEEP = 5;
  function arrow(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'gallery-more__arrow gallery-more__arrow--' + dir;
    b.setAttribute('aria-label', dir === 'next' ? 'Next photos' : 'Previous photos');
    b.textContent = dir === 'next' ? '›' : '‹';
    return b;
  }
  function split(ul) {
    if (ul.dataset.split) return;
    var items = Array.prototype.filter.call(ul.children, function (li) {
      return li.classList.contains('product__media-item');
    });
    if (items.length <= KEEP) return;
    ul.dataset.split = '1';
    var wrap = document.createElement('div');
    wrap.className = 'gallery-more';
    var track = document.createElement('ul');
    track.className = 'gallery-more__track list-unstyled';
    items.slice(KEEP).forEach(function (li) { track.appendChild(li); });
    var prev = arrow('prev'), next = arrow('next');
    function step(d) { track.scrollBy({ left: d * track.clientWidth, behavior: 'smooth' }); }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    wrap.appendChild(track);
    wrap.appendChild(prev);
    wrap.appendChild(next);
    ul.parentNode.insertBefore(wrap, ul.nextSibling);
    function sync() { var over = track.scrollWidth > track.clientWidth + 1; prev.hidden = next.hidden = !over; }
    requestAnimationFrame(sync);
    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);
  }
  function init() {
    if (!window.matchMedia('(min-width: 750px)').matches) return;
    document.querySelectorAll('.product--columns .product__media-list').forEach(split);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Phone lightbox: photos sit side by side (CSS), this opens on the clicked photo and keeps the n / total counter. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');
  function setup(modal) {
    if (modal.dataset.swipe) return;
    var content = modal.querySelector('.product-media-modal__content');
    var dialog = modal.querySelector('.product-media-modal__dialog');
    if (!content || !dialog) return;
    modal.dataset.swipe = '1';
    var count = document.createElement('div');
    count.className = 'product-media-modal__count';
    dialog.appendChild(count);
    function update() {
      var w = content.clientWidth || 1;
      var i = Math.round(content.scrollLeft / w);
      count.textContent = mq.matches ? (i + 1) + ' / ' + content.children.length : '';
    }
    content.addEventListener('scroll', update, { passive: true });
    new MutationObserver(function () {
      if (!modal.hasAttribute('open') || !mq.matches) return;
      setTimeout(function () {
        var active = content.querySelector('.active');
        var idx = active ? Array.prototype.indexOf.call(content.children, active) : 0;
        content.scrollLeft = Math.max(idx, 0) * content.clientWidth;
        update();
      }, 60);
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  }
  function init() { document.querySelectorAll('product-modal').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
